import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

  transform(collection: Array<any>, attribute: string): Array<any> {
    const hash: { [key: string]: Array<any> } = collection
      .reduce((acc: { [key: string]: Array<any> }, cur) => {
        if (cur[attribute]) {
          (acc[cur[attribute]] = acc[cur[attribute]] || []).push(cur);
        }
        return acc;
      }, {});
    return Object.keys(hash).map(key => hash[key]);
  }
}
